import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { tomos } from '../data/content';
export function Curriculum() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-12 sm:py-16" aria-labelledby="contenido-title" data-id="element-67" data-mp="20i096c2l8vnt">
      <div className="mx-auto max-w-3xl px-6" data-id="element-68" data-mp="25glayfxhnned">
        <div className="text-center" data-id="element-69" data-mp="2t5e464mq7h5a">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-oliva" data-id="element-70" data-mp="2t6fm8t25t3wi">
            Mindfulness para hockey
          </p>
          <h2 id="contenido-title" className="font-display text-3xl font-semibold tracking-tight text-tinta sm:text-4xl" data-id="element-71" data-mp="2jfbas3bp016f">
            El entrenamiento mental para cada práctica y cada partido
          </h2>
        </div>

        <div className="mt-8 divide-y divide-salvia/40 overflow-hidden rounded-4xl border border-salvia/40" data-id="element-72" data-mp="3c145rqqqybin">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={tomo.number} className="bg-white" data-id="element-73" data-mp="1jg6kfcpgknm9" data-mpi={index}>
                <h3 data-id="element-74" data-mp="1jhrez2brw6k4">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-6 text-left transition-colors duration-200 hover:bg-salvia/10 sm:px-8" data-id="element-75" data-mp="1je3lu4a8pm5x">
                    <span data-id="element-76" data-mp="225cxok7hgn0o">
                      <span className="block text-xs font-semibold uppercase tracking-[0.16em] text-oliva" data-id="element-77" data-mp="2264t9v12ykqy">
                        {tomo.number}
                      </span>
                      <span className="mt-1 block font-display text-lg font-semibold text-tinta sm:text-xl" data-id="element-78" data-mp="2b8e1ge8vm216">
                        {tomo.title}
                      </span>
                    </span>
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-salvia/25 text-bosque" data-id="element-79" data-mp="gud1fq1lb8zi">
                      {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="2ltvzoq06hh4p" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="2qsz54bk2lpd7" />}
                    </span>
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-82" data-mp="2usr8m9ulx5bp">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-83" data-mp="2zs2qxnamgive">
                      <ul className="space-y-3 px-6 pb-7 sm:px-8" data-id="element-84" data-mp="3ilpty0zfcbsf">
                        {tomo.items.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-relaxed text-tinta/70" data-id="element-85" data-mp="3nkatdy6uqrft">
                            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-oliva" aria-hidden="true" data-id="element-86" data-mp="16vrtl5fc2aaw" />
                            {item}
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}